import { isTruthy } from "../utils/helpers";

const isProd = process.env.ISPROD;

export const baseUrl = isTruthy(isProd) ? "https://admin.lucafantin.com/api/" : "https://admin.lucafantin.com/api/";

export const apiUrls = {
    "testimonials": "testimonials",
    "social_media": "social_media",
    "services": "services",
    "blogs": 'blogs',
    "contact_us": 'contact_us',
    "post_comment": 'post_comment',
    "service": "service",
    "blog": "blog"
};